import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { ContentType, Page } from '@tracking';

import Table from './Table';
import { TechSentimentData } from './interfaces';
import './styles.scss';

interface TechSentimentTrackerProps {
  projectId: number;
  techSentimentData: TechSentimentData;
}

const TechSentimentTracker = ({
  projectId,
  techSentimentData,
}: TechSentimentTrackerProps): JSX.Element => {
  const { Track } = useEventTracking({
    contentId: projectId,
    contentType: ContentType.Project,
    page: Page.Project,
    pageId: projectId,
  });

  return (
    <Track>
      <Table techSentimentData={techSentimentData} />
    </Track>
  );
};

export default TechSentimentTracker;
